"use client";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

const testimonials = [
  {
    name: "Priya Sharma",
    title: "Software Engineer",
    quote:
      "We always knew we needed to save for our daughter's education, but we didn't know where to begin. MySIPonline's planning tools helped us calculate the right SIP amount and gave us confidence that we're on the right track",
  },
  {
    name: "Rahul Patel",
    title: "Business Owner",
    quote:
      "Education costs keep rising every year, and that worried us. Using MySIPonline's Child Future Plan calculator helped us understand how inflation impacts our goals and how a disciplined SIP can bridge the gap.",
  },
  {
    name: "Anjali Desai",
    title: "Marketing Manager",
    quote:
      "Starting a SIP when our son was young turned out to be one of our best financial decisions. Even a modest monthly investment is steadily growing into a meaningful corpus for his higher education.",
  },
  {
    name: "Neha Gupta",
    title: "Government Employee",
    quote:
      "We had multiple goals for our child but no structured plan. MySIPonline helped us estimate future costs and create separate investment goals, making our financial planning far more organised and stress-free.",
  },
  {
    name: "Arjun Reddy",
    title: "Bank Manager",
    quote:
      "The biggest benefit wasn't just finding the right investment, it was knowing exactly how much we need to save. With regular SIPs and annual reviews, we finally feel prepared for our child's future instead of worrying about it.",
  },
];

const TestimonialSlider = () => {
  return (
    <div className="bg-[linear-gradient(180deg,#2A2C2F_0%,#3E4755_100%)] py-10 2md:py-8 2xl:py-16 mb-17.5 xxs:mb-100 2md:mb-20 2xl:mb-100">
      <div className="w-full mx-auto px-4">
        <h2 className="text-[24px] leading-8 2md:text-2.5xl 2md:leading-9 2xl:text-[32px] 2xl:leading-10 font-bold text-center text-[#E1AB20] mb-4">
          What Our Customers Say
        </h2>
        <p className=" text-sm 2md:text-base font-medium text-center mx-auto text-[#FCFCFC]">
          Listen to the hard work and dedication stories from our customers that MySIPonline puts into helping you
          succeed.
        </p>

        <Swiper
          modules={[Navigation]}
          loop
          spaceBetween={30}
          navigation={{
            prevEl: ".testimonial-prev",
            nextEl: ".testimonial-next",
          }}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1324: { slidesPerView: 4 },
          }}
          className="pb-20 cursor-grab"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index} className="pt-9 2md:pt-12 2xl:pt-20 ">
              <div className="relative bg-[#FFFFFF21] rounded-8xl px-4 2md:px-6 2xl:px-10 pb-5 pt-8 2md:pt-6 shadow-lg text-center border-3 border-[#FFFFFFC4]">
                <div className="w-12 h-12 2md:w-16 2md:h-16 2xl:w-20 2xl:h-20 absolute -top-7 2md:-top-8 2xl:-top-10 left-1/2 transform -translate-x-1/2 rounded-full bg-[#E1AB20] flex items-center justify-center text-[#2A2C2F] font-bold text-lg 2md:text-xl 2xl:text-2xl border-3 border-[#FFFFFFC4]">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="2md:mt-6 2xl:mt-12">
                  <p className="text-gray-300 text-sm  mb-3 2md:mb-6 h-100 overflow-auto scrollbar-none">
                    {testimonial.quote}
                  </p>
                  <p className="text-yellow-400 font-bold text-base 2md:text-lg">{testimonial.name}</p>
                  <p className="text-sm text-gray-400">{testimonial.title}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex justify-center gap-6 mt-4 2md:mt-8">
          <button className="testimonial-prev w-10 h-10 flex items-center justify-center rounded-full bg-[#FFFFFF33] border-2 border-[#FFFFFF] text-white hover:bg-white hover:text-black transition">
            &#8592;
          </button>
          <button className="testimonial-next w-10 h-10 flex items-center justify-center rounded-full bg-[#FFFFFF33] border-2 border-[#FFFFFF] text-white hover:bg-white hover:text-black transition">
            &#8594;
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;
